import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link,useOutletContext } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import ProgressBar from "react-bootstrap/ProgressBar";
import { MaterialReactTable } from "material-react-table";
import { colors } from "@mui/material";
import ByCollection from "../components/ByCollection";
import ByCollectionMonthly from "../components/ByCollectionMonthly";
import NetaddTrend from "../components/NetaddTrend";

function RevenueNetadd() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const [optionsWeekly, setOptionsWeekly] = useState([]);
  const [optionsMonthly, setOptionsMonthly] = useState([]);
  const [optionsQuarterly, setOptionsQuarterly] = useState([]);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };

    async function fetchOptions() {
        setGlobalLoading(true);
        try {
            const response = await axios.get(
            `${API_BASE_URL}/reports/get_revenue_netadd/`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
            );
            console.log(response.data.monthly_revenue_netadd);
            setOptionsWeekly(response.data.weekly_revenue_netadd[2] || []);
            setOptionsMonthly(response.data.monthly_revenue_netadd[1] || []);
            setOptionsQuarterly(response.data.quarterly_revenue_netadd[1] || []);
            const d = response.data;
            if (response.status == 200) {
                setData({
                ...d,
                });
            }
        } catch (error) {
            console.error("API Error:", error);
            setOptionsWeekly([]);
        } finally {
            setGlobalLoading(false); 
        }
    }
    
    useEffect(() => {
    if (token) fetchOptions();
    }, [token]);
      
    const currentFY =
  new Date().getMonth() + 1 >= 4
    ? new Date().getFullYear()
    : new Date().getFullYear() - 1;

    const fyLabels = Array.from({ length: 5 }, (_, i) => {
    const start = currentFY - i;
    const end = start + 1;
    return `${start}-${end}`;
    });
    return (
        <>
        <div className="card">
            <div className="card-body">
                <div className="border-bottom mb-3 pb-3">
                    <h4>Revenue Net Add</h4>
                </div>
                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
						<div className="table-responsive" style={{ maxHeight: "800px" }}>
						<div class="card-title mt-3">Week On Week Changes - Net Add</div>
                        <table className="table text-nowrap table-bordered" style={{ fontSize: "12px" }}>
							<thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
							<tr>
								<th>Week No.</th>
								{fyLabels.map((label, index) => (
                                    <th key={index}>{label}</th>
                                ))}
								<th>Difference(last yr & this yr)</th>
								<th>Difference(Target Compare)</th>
							</tr>
							</thead>

							<tbody>
							{optionsWeekly.map((row, index) => (
								<tr>
								<td>{row.week_label}</td>
								<td>{formatNumber(row.current_year)}</td>
								<td>{formatNumber(row.last_year)}</td>
								<td>{formatNumber(row.year_3)}</td>
								<td>{formatNumber(row.year_4)}</td>
								<td>{formatNumber(row.year_5)}</td>
								<td style={{color: row.diff_last_vs_current < 1 ? "red" : "green"}}>
                                    {Number(row.current_year) === 0
                                        ? "-"
                                        : formatNumber(Math.abs(row.diff_last_vs_current))}
                                </td>
                                <td style={{ color: row.diff_target < 1 ? "red" : "green"}}>
                                    {Number(row.current_year) === 0
                                    ? "-"
                                    : formatNumber(Math.abs(row.diff_target))}
                                </td>
								</tr>
							))}
							</tbody>
						</table>
						</div>        
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-6 col-xl-6 col-xxl-12">
                        <div className="card flex-fill">
                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                                Net-Add Monthly Trend
                            </h5>
                            </div>
                            <div className="card-body">
                            <NetaddTrend chart_data={optionsMonthly} type="monthly" />
                            </div>
                        </div>        
                    </div>
                    <div className="col-md-6 col-xl-6 col-xxl-12">
                        <div className="card flex-fill">
                            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                                Net-Add Quarterly Trend
                            </h5>
                            </div>
                            <div className="card-body">
                            <NetaddTrend chart_data={optionsQuarterly} type="quarterly"/>
                            </div>
                        </div>        
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                       <div className="table-responsive" style={{ maxHeight: "800px" }}>
						<div class="card-title mt-3">Monthly Changes - Net Add</div>
                        <table className="table text-nowrap table-bordered" style={{ fontSize: "12px" }}>
							<thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
							<tr>
								<th>Month</th>
								{fyLabels.map((label, index) => (
                                    <th key={index}>{label}</th>
                                ))}
								<th>Difference(last yr & this yr)</th>
							</tr>
							</thead>

							<tbody>
							{optionsMonthly.map((row, index) => (
								<tr>
								<td>{row.month_name}</td>
								<td>{formatNumber(row.current_year)}</td>
								<td>{formatNumber(row.last_year)}</td>
								<td>{formatNumber(row.year_3)}</td>
								<td>{formatNumber(row.year_4)}</td>
								<td>{formatNumber(row.year_5)}</td>
								<td style={{color: row.diff_last_vs_current < 1 ? "red" : "green"}}>
                                    {Number(row.current_year) === 0
                                        ? "-"
                                        : formatNumber(Math.abs(row.diff_last_vs_current))}
                                </td>
                            	</tr>
							))}
							</tbody>
						</table>
						</div> 
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                       <div className="table-responsive" style={{ maxHeight: "800px" }}>
						<div class="card-title mt-3">Quarter Changes - Net Add</div>
                        <table className="table text-nowrap table-bordered" style={{ fontSize: "12px" }}>
							<thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
							<tr>
								<th>Quarter</th>
								{fyLabels.map((label, index) => (
                                    <th key={index}>{label}</th>
                                ))}
								<th>Difference(last yr & this yr)</th>
							</tr>
							</thead>

							<tbody>
							{optionsQuarterly.map((row, index) => (
								<tr>
								<td>{row.quarter_name}</td>
								<td>{formatNumber(row.current_year)}</td>
								<td>{formatNumber(row.last_year)}</td>
								<td>{formatNumber(row.year_3)}</td>
								<td>{formatNumber(row.year_4)}</td>
								<td>{formatNumber(row.year_5)}</td>
								<td style={{color: row.diff_last_vs_current < 1 ? "red" : "green"}}>
                                    {Number(row.current_year) === 0
                                        ? "-"
                                        : formatNumber(Math.abs(row.diff_last_vs_current))}
                                </td>
                            	</tr>
							))}
							</tbody>
						</table>
						</div> 
                    </div>
                </div>    
            </div>    
        </div>
        </>
    );
}

export default RevenueNetadd;